export const mapStateToProps = ({
  ledger: { deleted: documentDeleted, deletingRecord: deletingDocument },
}) => ({
  documentDeleted,
  deletingDocument,
})

export const handlers = (EVENTS) => ({
  deleteDocument:
    ({ trackEvent, deletingDocument }) =>
    () => {
      const { name } = EVENTS.DELETE_DOCUMENT
      const documentName = deletingDocument?.name?.documentName
      trackEvent(name, { name: documentName })
    },
  downloadReport:
    ({ trackEvent, downloadingReport: { name: reportName } }) =>
    () => {
      const { name } = EVENTS.DOWNLOAD_REPORT
      trackEvent(name, { name: reportName })
    },
})

export const onComponentDidUpdate = (prevProps, props) => {
  const { documentDeleted } = props
  if (documentDeleted !== prevProps.documentDeleted && documentDeleted) {
    props.deleteDocument()
  }
}
